// src/utils/updateTabTitle.js
import logo from '../assets/logo1.png';

export const updateTabTitle = (title = 'Anphitrion Hotel Web') => {
  document.title = title;
};

export const updateFavicon = () => {
  const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = logo;
  document.getElementsByTagName('head')[0].appendChild(link);
};